
export const apiKeys = {
    firebaseApiKey: process.env.REACT_APP_FIREBASE_KEY,
    googleId: process.env.REACT_APP_GOOGLE_ID,
}




